export const COUNTRY_SELECTION_STORAGE_NAME = "country";
